module.exports = __webpack_public_path__ + "img/1445436826.fe310f55.jpg";